  const nativeObserve = ResizeObserver.prototype.observe;
  const nativeUnobserve = ResizeObserver.prototype.unobserve;

  ResizeObserver.prototype.observe = function (target: Element, options?: ResizeObserverOptions): void
  {
      if (target?.nodeType === Node.ELEMENT_NODE)
          nativeObserve.call(this, target, options);
  };

  ResizeObserver.prototype.unobserve = function (target: Element): void
  {
      if (target?.nodeType === Node.ELEMENT_NODE)
          nativeUnobserve.call(this, target);
  };
